export default __webpack_public_path__ + "static/media/orange_dao.d243feb6.svg";